<template>
  <table :class="{ now: isImmediatePayment }" class="total-stay">
    <tbody>
      <tr>
        <td>
          <translate class="amount">Total stay</translate>
          <translate tag="div">(excluding optional extras)</translate>
        </td>
        <td class="amount">
          <pu-price :price="price" :display-original-price="true" /><span
            v-if="offersActive"
            class="offer-color"
            >*</span
          >
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { SimpleMoney } from '~/utility/money'

@Component
class TotalStay extends Vue {
  @Prop()
  price: SimpleMoney

  @Prop()
  offersActive: boolean

  @Prop()
  isImmediatePayment: boolean
}

export default toNative(TotalStay)
</script>
